<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import {ModelListSelect} from "vue-search-select";
import Loader from "@/components/widgets/preloader";
import {mapGetters, mapActions, mapState} from "vuex"
import Swal from "sweetalert2";
import moment from "moment";
import DataTable from "@/components/DataTable.vue";


export default {
  page: {
    title: "Debtors",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ModelListSelect,
    Loader,
    DataTable,
  },
  data() {
    return {
      title: "Credit Sales",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Debtors",
          active: true,
        },
      ],
      pageOptions: [10, 25, 50, 100, 200, 1000],
      serverPerPage: 50,
      IsDebtorsDataServerPaginated: true,
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      modal_id: "",
      clear: {
        id: "",
        date: null,
        paid: "",
        mode: "",
        totals: "",
        filterdata: {},
        payments: [{ method: null, amount: '' }], // For split payments
      },

      data: {
        dateto: moment(new Date()).format("YYYY-MM-DD"),
        datefrom: moment(new Date()).format("YYYY-MM-DD"),
        customer: "",
        branch_id: 0,
        user: "",
        page: 1,
        per_page: 50,
      },
      amountError: "",
      modeError: "",
      balance: 0,
      splitPaymentActive: false,

      edit: {
        id: '',
        name: '',
        pay_date: '',
      }
    };
  },
  computed: {
    ...mapState("notification", [
      "type",
      "message",
      "show",
    ]),
    ...mapGetters("saledetails", ["SaveStatus", "filterStatus", "DebtorsData", "DebtorsDataPagination", "DebtorsDataSummary","DebtorsDataPaginated"]),
    ...mapGetters("setting", ["PaymentOptions", "GeneralSettings", "ReceiptSettings"]),
    ...mapGetters("auth", ["MyUserPerm", "business", "branch", "Branches", "branchid"]),
    ...mapGetters("customers", ["Customers"]),
    ...mapState("saledetails", ["saleId"]),
    ...mapGetters("users", ["Users"]),

    rows() {
      return this.IsDebtorsDataServerPaginated
          ? this.DebtorsDataPagination?.total
          : this.DebtorsData ? this.DebtorsData.length : 0;
    },

    perPage: {
      get() {
        if (this.IsDebtorsDataServerPaginated) {
          return (
            (this.DebtorsDataPagination &&
              this.DebtorsDataPagination.per_page) ||
            this.data.per_page ||
            this.serverPerPage
          );
        } else {
          return this.serverPerPage;
        }
      },
      set(value) {
        if (this.IsDebtorsDataServerPaginated) {
          this.data.per_page = value;
          this.data.page = 1;
          this.FetchDebtorsData(this.data);
        } else {
          this.serverPerPage = value;
        }
      },
    },

    currentPage: {
      get() {
        return this.DebtorsDataPaginated && this.DebtorsDataPagination
          ? this.DebtorsDataPagination.current_page
          : 1;
      },
      set(value) {
        if (this.DebtorsDataPaginated) {
          this.data.page = value;
          this.handlePageChange(value);
        }
      },
    },

    totals() {
      return this.DebtorsDataSummary || {
        totalAmount: 0,
        totalPaid: 0,
        totalDiscount: 0,
        totalBalance: 0,
      };
    },

    totalPaidFromSplits() {
      if (!this.clear.payments || this.clear.payments.length === 0) {
        return 0;
      }
      return this.clear.payments.reduce((acc, payment) => {
        const amount = parseFloat(String(payment.amount).replace(/,/g, '')) || 0;
        return acc + amount;
      }, 0);
    },

     debtorColumns() {
      const cols = [
        {
          key: "sn",
          label: "S/N",
          formatter: (_, __, idx) => this.DebtorsDataPagination.from + idx,
        },
        {
          key: "customer",
          label: "CUSTOMER",
          formatter: (_, row) =>
            `${row.customerobj?.name ?? "N/A"} - ${row.customerobj?.contact ?? ""}`,
        },
      ];

      if (this.GeneralSettings.set_debtpay_date != 0) {
        cols.push(
          { key: "date", label: "DATE" },
          {
            key: "pay_date",
            label: "EXPECTED PAY DATE",
            formatter: (_, row) => {
              try {
                return new Date(row.pay_date).toISOString().split("T")[0];
              } catch {
                return "N/A";
              }
            },
          },
          {
            key: "remaining_days",
            label: "DAYS REMAINING",
            formatter: (_, row) => {
              const now = new Date(new Date().toISOString().split("T")[0]);
              const pay = new Date(row.pay_date);
              const days = Math.floor((pay - now) / (1000 * 60 * 60 * 24));
              return `${days} days`;
            },
          }
        );
      }

      // Common columns
      cols.push(
        {
          key: "totalAmt",
          label: "TOTAL",
          formatter: (v) => this.thousandSeperator(v),
        },
        {
          key: "totalPaid",
          label: "PAID",
          formatter: (v) => this.thousandSeperator(v),
        },
        {
          key: "discount",
          label: "DISCOUNT",
          formatter: (v) => this.thousandSeperator(v),
        },
        {
          key: "balance",
          label: "BALANCE",
          formatter: (v) => this.thousandSeperator(v ?? 0),
        },
        { key: "receipt", label: "RECEIPT" },
        { key: "user", label: "RECORDED BY" },
        { key: "products", label: "PRODUCTS" },
        { key: "actions", label: "ACTIONS", tdClass: "text-nowrap" }
      );

      return cols;
    },
  },
  watch: {
    show(newValue) {
      if (newValue == true) {
        if (this.type == "success") {
          this.closeModal(this.modal_id);
          Swal.fire("Success!", this.message.msg, "success");
        } else {
          Swal.fire("Error!", this.message.msg, "error");
        }
      }
    },
    saleId(newValue) {
      if (newValue && this.ReceiptSettings.print_receipt_after_sale == 1) {
        if (this.ReceiptSettings.receipt_type == 1) {
          window.open(
              `https://${window.location.host}/receipts/debtreceipt.php?id=${btoa(newValue)}`
          );
        } else if (this.ReceiptSettings.receipt_type == 2) {
          window.open(
              `https://${window.location.host}/receipts/debtreceiptv2.php?id=${btoa(newValue)}`
          );
        } else if (this.ReceiptSettings.receipt_type == 3) {
          window.open(
              `https://${window.location.host}/receipts/debtreceiptv3.php?id=${btoa(newValue)}`
          );
        } else if (this.ReceiptSettings.receipt_type == 4) {
          window.open(
              `https://${window.location.host}/receipts/debtreceiptv4.php?id=${btoa(newValue)}`
          );
        } else {
          window.open(
              `https://${window.location.host}/receipts/debtreceipt.php?id=${btoa(newValue)}`
          );
        }
      }
    },
    PaymentOptions(newValue) {
      if (newValue) {
        this.setDefaultMode();
      }
    }
  },
  methods: {
    ...mapActions({
      FetchDebtorsData: "saledetails/fetchDebtorsData",
      ClearBalance: "saledetails/ClearDebt",
      ClearBalancePrint: "saledetails/ClearDebtPrint",
      FetchModes: "setting/fetchPaymentOptions",
      FetchGeneralSettings: "setting/fetchGeneralSettings",
      FetchReceiptSettings: "setting/fetchReceiptSettings",
      FetchCustomers: "customers/fetchCustomers",
      FetchBranches: "auth/fetchBranches",
      editPaydate: "saledetails/editPaydate",
      FetchUsers: "users/fetchUsers",
    }),

    onFiltered() {
      if (!this.IsDebtorsDataServerPaginated) {
        this.clientCurrentPage = 1;
      }
    },

    thousandSeperator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
            .toString()
            .replace(/\D/g, "")
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },

    setDefaultMode() {
      let defaultop = this.PaymentOptions ? this.PaymentOptions : [].filter((mode) => {
        return mode.default == 1;
      })
      this.clear.mode = defaultop[0] ? defaultop[0].id : 0;
    },

    resetModal() {
      this.clear.id = "";
      this.clear.paid = "";
      this.setDefaultMode();
      this.clear.total = "";
      this.resetSplitPayments();
    },

    resetError() {
      this.amountError = "";
      this.modeError = "";
    },

    addCommas() {
      this.clear.paid = this.thousandSeperator(this.clear.paid);
    },

    ShowClear(data) {
      this.clear.id = data.id;
      this.balance = data.balance;
      this.clear.paid = (data.totalAmt - (data.totalPaid + data.discount)).toLocaleString();
      this.clear.total = data.totalAmt;
    },

    checkAmt() {
      if (this.clear.paid.replace(/,/g, '') > this.balance && this.GeneralSettings.deposit_balances == 0) {
        this.amountError = "Amount Paid is greater than balance";
        return
      } else {
        this.amountError = "";
      }
    },

    clearAmt(modalId) {
      this.modal_id = modalId;
      if (this.clear.paid == "") {
        this.amountError = "Amount Paid is required";
        return
      } else {
        this.amountError = "";
      }
      if (this.clear.paid.replace(/,/g, '') > this.balance && this.GeneralSettings.deposit_balances == 0) {
        this.amountError = "Amount Paid is greater than balance";
        return
      } else {
        this.amountError = "";
      }
      if (this.clear.mode == "") {
        this.modeError = "Payment Method is required";
        return
      } else {
        this.modeError = "";
      }
      this.clear.filterdata = this.data;
      this.ClearBalance(this.clear);
    },

    clearAmtPrint(modalId) {
      this.modal_id = modalId;
      if (this.clear.paid == "") {
        this.amountError = "Amount Paid is required";
        return
      } else {
        this.amountError = "";
      }
      if (this.clear.paid.replace(/,/g, '') > this.clear.total && this.GeneralSettings.deposit_balances == 0) {
        this.amountError = "Amount Paid is greater than balance";
        return
      } else {
        this.amountError = "";
      }
      if (this.splitPaymentActive) {
          this.clear.payments = this.clear.payments.filter(p => p.method && p.amount && parseFloat(String(p.amount).replace(/,/g, '')) > 0);
          if (this.clear.payments.length === 0) {
              this.modeError = "At least one valid split payment is required.";
              return;
          }
          this.clear.paid = this.totalPaidFromSplits;
      } else {
          if (!this.clear.mode) {
              this.modeError = "Payment Method is required.";
              return;
          }
          this.clear.paid = parseFloat(String(this.clear.paid).replace(/,/g, '')) || 0;
          this.clear.payments = [{ method: this.clear.mode, amount: this.clear.paid }];
      }
      this.modeError = "";
      this.clear.filterdata = this.data;
      this.ClearBalancePrint(this.clear);
    },

    closeModal(modalId) {
      this.resetError();
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },

    filterReport() {
      let payload = { ...this.data };
      payload.page = 1;
      payload.per_page = this.IsDebtorsDataServerPaginated
        ? this.perPage
        : this.serverPerPage;

      this.FetchDebtorsData(payload);
    },

    handlePageChange(newPage) {
      if (this.IsDebtorsDataServerPaginated) {
        this.data.page = newPage;
        this.FetchDebtorsData(this.data);
      }
    },

    ShowEdit(data) {
      this.edit.id = data.id;
      this.edit.name = data.customer + '-' + data.customerPhone;
      this.edit.pay_date = new Date(data.pay_date);
    },

    EditPayDate() {
      this.edit.filterdata = this.data;
      this.editPaydate(this.edit);
    },

    // *** SPLIT PAYMENT LOGIC ***
    submitSplits(modalId) {
        this.clear.payments = this.clear.payments.filter(p => p.method && p.amount && parseFloat(String(p.amount).replace(/,/g, '')) > 0);
        if (this.clear.payments.length === 0) {
            this.clear.payments.push({ method: null, amount: '' });
            return;
        }

        this.isSubmittingSplits = true;
        this.splitPaymentActive = true;
        const totalFromSplits = this.totalPaidFromSplits;
        this.clear.paid = (totalFromSplits.toLocaleString());
        this.closeModal(modalId);
    },

    onPaymentsModalHidden() {
      if (this.isSubmittingSplits) {
        this.isSubmittingSplits = false;
      } else {
        this.resetSplitPayments();
      }
    },

    resetSplitPayments() {
      const originalPayments = this.splitPaymentActive ? [{ method: null, amount: '' }] : this.clear.payments;
      this.clear.payments = originalPayments;

      if (this.splitPaymentActive) {
        this.clear.paid = 0;
        this.splitPaymentActive = false;
      }
    },
    // End of Split Payments

    checkAndAddPaymentField(index) {
      const lastIndex = this.clear.payments.length - 1;
      const currentPayment = this.clear.payments[index];
      if (index === lastIndex && currentPayment.amount && currentPayment.method) {
        this.clear.payments.push({ method: null, amount: '' });
      }
    },

    removePaymentField(index) {
      if (this.clear.payments.length > 1) {
        this.clear.payments.splice(index, 1);
      }
    },
    
    formatAndSetAmount(event, index) {
      let raw = event.target.value.replace(/,/g, '');
      if (!/^\d*\.?\d*$/.test(raw)) return;

      this.clear.payments[index].amount = raw;

      this.$nextTick(() => {
        const el = event.target;
        if(el.value) {
            el.value = Number(raw).toLocaleString();
        }
        this.checkAndAddPaymentField(index);
      });
    },
  },

  created() {
    this.FetchBranches();
    this.FetchDebtorsData(this.data);
    this.FetchGeneralSettings();
    this.FetchReceiptSettings();
    this.FetchCustomers();
    this.FetchModes();
    this.setDefaultMode();
    this.FetchUsers();
  },
};
</script>

<template>
  <Layout>
    <div class="row py-3 text-center">
      <h4 v-if="GeneralSettings.show_businessname == 1" class="text-primary">{{ business }}</h4><h4
        v-if="GeneralSettings.show_branchname == 1 && branch"><em
        v-if="GeneralSettings.show_branchname == 1 && GeneralSettings.show_businessname == 1">-</em> {{ branch }}</h4>
    </div>
    <PageHeader :title="title" :items="items"/>

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <h4 class="card-title text-center">Items Sold On Credit from {{ data.datefrom }} to {{ data.dateto }}</h4>
            </div>

            <div class="row">
              <div class="col-md-4 form-group mb-3">
                <label>USERS</label>
                <model-list-select
                    :list="Users ? [ { id: '', names: 'All Users' }, ...Users ] : []"
                    v-model="data.user"
                    option-value="id"
                    option-text="names"
                    placeholder="Select User"
                    @input="filterReport()"
                >
                </model-list-select>
              </div>
              <div class="col-md-4 mb-3" v-if="branchid == 0">
                <label>FILTER BY BRANCHES</label>

                <model-list-select
                    :list="Branches ? Branches : []"
                    v-model="data.branch_id"
                    option-value="id"
                    option-text="name"
                    placeholder="Select Branch"
                    @input="filterReport()"
                >
                </model-list-select>
              </div>
              <div v-else class="col-md-8" align="right">
                <router-link to="/sales/imported_debtors">
                  <b-button variant="info">Imported Debtors</b-button>
                </router-link>
              </div>
            </div>
            <div class="row">
              <div class="col-3">
                <div class="form-group">
                  <label>From</label>
                  <input
                      type="date"
                      v-model="data.datefrom"
                      class="form-control"
                      v-limit-future-date
                  />
                </div>
              </div>
              <div class="col-3">
                <div class="form-group">
                  <label>To</label>
                  <input
                      type="date"
                      v-model="data.dateto"
                      class="form-control"
                      v-limit-future-date
                  />
                </div>
              </div>
              <div class="col-md-4 form-group">
                <label>CUSTOMERS</label>
                <model-list-select
                    :list="Customers ? [ { id: '', name: 'All Customers' }, ...Customers ] : []"
                    v-model="data.customer"
                    option-value="id"
                    option-text="name"
                    placeholder="Select Customer"
                    @input="filterReport()"
                >
                </model-list-select>
              </div>
              <div class="col-md-2 mt-4">
                <button class="btn btn-primary" type="button" @click="filterReport()">
                  <span class="fa fa-filter"></span> Filter
                  <b-spinner
                      v-show="filterStatus"
                      variant="light"
                      small
                      role="status"
                  ></b-spinner>
                </button>
              </div>
            </div>

            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                        class="form-select form-select-sm"
                        v-model="perPage"
                        size="sm"
                        :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-end"
                    v-if="!IsDebtorsDataServerPaginated"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                        v-model="filter"
                        type="search"
                        placeholder="Search..."
                        class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>

            <!-- Table -->
            <div class="table-responsive mb-0">
              <DataTable
                :columns="debtorColumns"
                :rows="DebtorsData"
                :total-rows="rows"
                :pagination="DebtorsDataPagination"
                :server-pagination="IsDebtorsDataServerPaginated"
                :loading="filterStatus"
                row-class="debtor-table-bordered"
              >
                <template #cell(sn)="{ index }">
                  {{ DebtorsDataPagination.from + index }}
                </template>

                <template #cell(customer)="{ row }">
                  {{ row.customerobj?.name }} - {{ row.customerobj?.contact }}
                </template>

                <template v-if="GeneralSettings.set_debtpay_date != 0" #cell(date)="{ value }">
                  {{ value }}
                </template>

                <template v-if="GeneralSettings.set_debtpay_date != 0" #cell(pay_date)="{ row }">
                  <span
                    class="text-warning"
                    style="cursor: pointer"
                    v-b-modal.edit_paydate-modal
                    @click="ShowEdit(row)"
                  >
                  {{
                  row.pay_date && !isNaN(new Date(row.pay_date))
                    ? new Date(row.pay_date).toISOString().split("T")[0]
                    : "N/A"
                }}
                  </span>
                </template>

                <template v-if="GeneralSettings.set_debtpay_date != 0" #cell(remaining_days)="{ row }">
                  {{
                    Math.floor(
                      (new Date(row.pay_date) -
                        new Date(new Date().toISOString().split("T")[0])) /
                        (1000 * 60 * 60 * 24)
                    )
                  }} days
                </template>

                <template #cell(totalAmt)="{ value }">
                  {{ thousandSeperator(value) }}
                </template>

                <template #cell(totalPaid)="{ value }">
                  {{ thousandSeperator(value) }}
                </template>

                <template #cell(discount)="{ value }">
                  {{ thousandSeperator(value) }}
                </template>

                <template #cell(balance)="{ value }">
                  {{ thousandSeperator(value ?? 0) }}
                </template>

                <template #cell(receipt)="{ value }">
                  {{ value }}
                </template>

                <template #cell(user)="{ value }">
                  {{ value }}
                </template>

                <template #cell(products)="{ row }">
                  <div v-for="(det, d) in row.items" :key="d" class="mb-2">
                    {{ det.product }} — {{ det.qty }}{{ det.usymbol }}
                  </div>
                </template>

                <template #cell(actions)="{ row }">
                  <div v-if="MyUserPerm.clear_debtors == 1">
                    <button @click="ShowClear(row)" class="btn btn-primary btn-sm" v-b-modal.clear-modal>
                      <i class="fa fa-check"></i> Clear
                    </button>
                  </div>
                </template>
              </DataTable>


              <div class="row">
                <div class="col-md-3">
                  <h5>Total Amount: <span class="text-danger">{{ totals.totalAmount.toLocaleString() }}</span></h5>
                </div>
                <div class="col-md-3">
                  <h5>Total Paid: <span class="text-danger">{{ totals.totalPaid.toLocaleString() }}</span></h5>
                </div>
                <div class="col-md-3">
                  <h5>Total Discount: <span class="text-danger">{{ totals.totalDiscount.toLocaleString() }}</span></h5>
                </div>
                <div class="col-md-3">
                  <h5>Total Balance: <span class="text-danger">{{ totals.totalBalance.toLocaleString() }}</span></h5>
                </div>
              </div>
            </div>
            <Loader v-if="!DebtorsData"/>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                        aria-controls="tickets-table"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Edit buying price modal starts -->
    <b-modal id="edit_paydate-modal" hide-footer>
      <template #modal-title>
        <h4 class="text-warning">Edit Pay Date for {{ edit.name }}'s debt'</h4></template
      >
      <label>Expected Payment Date</label>
      <div class="input-group">
        <input
            type="date"
            class="form-control"
            v-model="edit.pay_date"
            placeholder="Expected Payment Date"
        />
      </div>
      <div class="modal-footer">
        <button
            type="button"
            class="btn btn-secondary"
            data-dismiss="modal"
            @click="closeModal('edit_paydate-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button type="button" class="btn btn-warning" @click="EditPayDate()">
          <i class="fa fa-minus"></i> Confirm
          <b-spinner
              v-if="SaveStatus"
              variant="light"
              small
              label="Submiting"
          ></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->

    <!-- modal clear debtor starts -->
    <b-modal id="clear-modal" hide-footer @hidden="resetModal()">
      <template #modal-title>
        <h4 class="text-warning">Clear Credit of {{ (clear.paid).toLocaleString() }}</h4></template
      >
      <div class="d-flex align-items-center">
        <label class="mb-0 mr-4">
          Amount Paid <span class="text-danger">*</span> 
        </label>
        <span class="my-1 px-5">
        <b-button variant="link" class="border border-primary border-1" v-b-modal.add-payments-modal>
          <i class="fa fa-columns"></i> Split Payment 
        </b-button>
        </span>
      </div>
      <div class="input-group">
        <input
          type="text"
          class="form-control"
          v-model="clear.paid"
          placeholder="Amount Paid"
          @input="resetError(),addCommas(),checkAmt()"
        />
      </div>
      <div class="text-danger" v-if="amountError">
        <em>{{ amountError }}</em>
      </div>
      <div class="form-group">
        <label>Payment Method <span class="text-danger">*</span></label>
        <model-list-select
            :list="PaymentOptions ? PaymentOptions : []"
            v-model="clear.mode"
            option-value="id"
            option-text="mode"
            placeholder="Select Method"
            @input="resetError()"
            :is-disabled="splitPaymentActive"
        >
        </model-list-select>
      </div>
      <div class="text-danger" v-if="modeError">
        <em>{{ modeError }}</em>
      </div>
      <div class="form-group" v-if="MyUserPerm.backdate_payments == 1">
        <label>Payment Date</label>
        <div class="input-group">
          <input
              type="date"
              class="form-control"
              v-model="clear.date"
              v-limit-future-date
          />
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-md-4">
          <button v-if="SaveStatus" type="button" class="btn btn-warning" disabled>
            Confirm & Print
            <b-spinner
                variant="light"
                small
                label="Submiting"
            ></b-spinner>
          </button>
          <button v-else type="button" class="btn btn-warning" @click="clearAmtPrint('clear-modal')">
            Confirm & Print
          </button>
        </div>
        <div class="col-md-4"></div>
        <div class="col-md-4">
          <button v-if="SaveStatus" type="button" class="btn btn-warning" disabled>
            Confirm & Exit
            <b-spinner
                variant="light"
                small
                label="Submiting"
            ></b-spinner>
          </button>
          <button v-else type="button" class="btn btn-warning" @click="clearAmt('clear-modal')">
            Confirm & Exit
          </button>
        </div>
      </div>
    </b-modal>

    <!-- SPLIT PAYMENTS MODAL -->
    <b-modal id="add-payments-modal" size="lg" hide-footer @hidden="onPaymentsModalHidden" title="Add Split Payments">
      <div v-for="(payment, index) in clear.payments" :key="index" class="mb-2">
        <div class="row align-items-center">
          <div class="col-6">
            <label v-if="index === 0">Payment Method</label>
            <model-list-select
              :list="PaymentOptions ? PaymentOptions : []"
              v-model="payment.method"
              option-value="id"
              option-text="mode"
              placeholder="Select Method"
              @input="checkAndAddPaymentField(index)"
            >
            </model-list-select>
          </div>
          <div class="col-4">
            <label v-if="index === 0">Amount Paid</label>
            <input
              :value="payment.amount ? Number(payment.amount).toLocaleString() : ''"
              @input="formatAndSetAmount($event, index)"
              class="form-control"
              placeholder="Enter Amount"
            />
          </div>
          <div class="col-2">
            <label v-if="index === 0 && clear.payments.length > 1">Remove</label>
            <div class="d-flex align-items-end">
              <button
                v-if="clear.payments.length > 1"
                class="btn btn-outline-danger"
                type="button"
                @click="removePaymentField(index)"
              >
                <i class="fa fa-times"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" @click="closeModal('add-payments-modal')">Cancel</button>
        <button type="button" class="btn btn-primary" @click="submitSplits('add-payments-modal')"><i class="fa fa-check"></i> Submit Payments</button>
      </div>
    </b-modal>
    <!-- END SPLIT PAYMENTS MODAL -->
  </Layout>
</template>

<style>
.btn-primary, .page-link {
  background-color: #FAB031 !important;
  border-color: #FAB031 !important;
}
</style>